import type { IsoYearAndWeekWithWeekday } from '../../types/iso-date';

/**
 * Validates an ISO 8601 year-week-with-weekday string: YYYY-Www-D
 * - Week: 01–53 (leading zero required)
 * - Weekday: 1–7 (1=Mon .. 7=Sun)
 * - Week 53 is only valid for years that actually have 53 ISO weeks
 */
export function isIsoYearAndWeekWithWeekday(str: string): str is IsoYearAndWeekWithWeekday {
  const m = /^(\d{4})-W(0[1-9]|[1-4]\d|5[0-3])-([1-7])$/.exec(str);
  if (!m) return false;

  const year = Number(m[1]);
  const week = Number(m[2]);
  // weekday captured but range already enforced by regex

  if (week < 53) return true;
  return hasIsoWeek53(year);
}

// A year has 53 ISO weeks if Jan 1 is a Thursday (ISO weeks start Monday),
// or if it is a leap year and Jan 1 is a Wednesday.
function hasIsoWeek53(year: number): boolean {
  const jan1 = new Date(Date.UTC(year, 0, 1));
  const day = jan1.getUTCDay(); // 0=Sun,1=Mon,...,4=Thu
  const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  return day === 4 || (isLeap && day === 3);
}

